import React from 'react';
import { IconProps } from './types';

const RaiseRequestIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect y="0.000152588" width="24" height="24" rx="4" fill="#EAF6F6" />
      <mask id="mask0_628_4599" maskUnits="userSpaceOnUse" x="4" y="4" width="16" height="17">
        <rect x="4" y="4.00015" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g>
        <path
          d="M14.6662 9.59983L8.73288 15.5332C8.61066 15.6554 8.4551 15.7165 8.26621 15.7165C8.07732 15.7165 7.92177 15.6554 7.79954 15.5332C7.67732 15.4109 7.61621 15.2554 7.61621 15.0665C7.61621 14.8776 7.67732 14.722 7.79954 14.5998L13.7329 8.66649H8.66621C8.47732 8.66649 8.31899 8.6026 8.19121 8.47483C8.06343 8.34705 7.99954 8.18872 7.99954 7.99983C7.99954 7.81094 8.06343 7.6526 8.19121 7.52483C8.31899 7.39705 8.47732 7.33316 8.66621 7.33316H15.3329C15.5218 7.33316 15.6801 7.39705 15.8079 7.52483C15.9357 7.6526 15.9995 7.81094 15.9995 7.99983V14.6665C15.9995 14.8554 15.9357 15.0137 15.8079 15.1415C15.6801 15.2693 15.5218 15.3332 15.3329 15.3332C15.144 15.3332 14.9857 15.2693 14.8579 15.1415C14.7301 15.0137 14.6662 14.8554 14.6662 14.6665V9.59983Z"
          fill="#29A1A3"
        />
      </g>
    </svg>
  );
};
export default RaiseRequestIcon;
